import DashboardIcon from "@rsuite/icons/Dashboard";
import PeoplesIcon from "@rsuite/icons/Peoples";
import MessageIcon from "@rsuite/icons/Message";
import SettingIcon from "@rsuite/icons/Setting";
import GearIcon from "@rsuite/icons/Gear";
import PeopleBranchIcon from "@rsuite/icons/PeopleBranch";
import ExitIcon from "@rsuite/icons/Exit";
import CalendarIcon from "@rsuite/icons/Calendar";
import GrowthIcon from "@rsuite/icons/Growth";
import WechatCustomerOutlineIcon from '@rsuite/icons/WechatCustomerOutline';
export const items = [
  {
    id: 1,
    type: "button",
    title: "dashboard",
    value: "dashboard",
    icon: <DashboardIcon />,
    sectionName:"dashboard"
  },
  {
    id: 2,
    type: "button",
    title: "products",
    value: "products",
    icon: <SettingIcon />,
    sectionName:"my_products"
  },
  {
    id: 3,
    type: "button",
    title: "bookings",
    value: "bookings",
    icon: <CalendarIcon />,
    sectionName:"my_bookings"
  },
  {
    id: 4,
    type: "button",
    title: "invoices",
    value: "invoices",
    icon: <GrowthIcon />,
    sectionName:"ho_act_facturation"
  },
  {
    id: 5,
    type: "button",
    title: "networks",
    value: "networks",
    icon: <PeopleBranchIcon />,
    sectionName:"networks"
  },
  {
    id: 6,
    type: "button",
    title: "chat",
    value: "chat",
    icon: <MessageIcon />,
    sectionName:"chat"
  },
  {
    id: 7,
    type: "button",
    title: "users",
    value: "users",
    icon: <PeoplesIcon />,
    sectionName:"users"
  },
  {
    id: 8,
    type: "button",
    title: "settings",
    value: "settings",
    icon: <GearIcon />,
    sectionName:"settings"
  },
    {
    id: 10,
    type: "button",
    title: "tickets",
    value: "tickets",
    icon: <WechatCustomerOutlineIcon />,
    sectionName:"support_tickets"
  },
  {
    id: 9,
    type: "button",
    title: "quit",
    value: "quit",
    icon: <ExitIcon />,
  },
];
